<template>
    <div class="cloud-market">
        <!-- banner -->
        <div class="cm_banner bg_cover">
            <div class="iot common_1180">
                <p class="iotFont" data-aos="my-fadeIn" data-aos-once="true">云市场</p>
                <p class="iotContent" data-aos="my-fadeIn" data-aos-once="true">
                    在这里您可以买到业务发展所需的各类产品和服务，精选服务商，保障
                </p>
                <p class="iotContent" data-aos="my-fadeIn" data-aos-once="true">
                    服务质量，支持先试用再购买。
                </p>
            </div>
        </div>
        <!-- 应用市场 -->
        <div class="cm_example bg_ff">
            <div class="example_app common_1180 example_main">
                <img data-aos="my-fadeIn" data-aos-once="true" class="img_1" src="../../assets/img/application-market/cm1.png" alt="">
                <div class="app_main">
                    <p class="cm_title" data-aos="my-fadeIn" data-aos-once="true">{{list[0].title}}</p>
                    <p class="cm_des" data-aos="my-fadeIn" data-aos-once="true">{{list[0].des}}</p>
                    <ul>
                        <li v-for="item in list[0].ul" :key="item.id" data-aos="my-fadeIn" data-aos-once="true">
                            <div class="li_top">
                                <div class="icon">
                                    <img src="../../assets/img/application-market/icon-cm.png" alt="">
                                </div>
                                <p class="title">{{item.title}}</p>
                            </div>
                            <p class="li_des">{{item.des}}</p>
                        </li>
                    </ul>
                    <p class="cm_btn" data-aos="my-fadeIn" data-aos-once="true" @click="toDetail(list[0].url,list[0].open)">查看详情</p>
                </div>
            </div>
        </div>
        <!-- 众包市场 -->
        <div class="cm_example bg_f8">
            <div class="example_supply common_1180 example_main">
                <img class="img_1" data-aos="my-fadeIn" data-aos-once="true" src="../../assets/img/application-market/cm2.png" alt="">
                <div class="app_main">
                    <p class="cm_title" data-aos="my-fadeIn" data-aos-once="true">{{list[1].title}}</p>
                    <p class="cm_des" data-aos="my-fadeIn" data-aos-once="true">{{list[1].des}}</p>
                    <ul>
                        <li v-for="item in list[1].ul" :key="item.id" data-aos="my-fadeIn" data-aos-once="true">
                            <div class="li_top">
                                <div class="icon">
                                    <img src="../../assets/img/application-market/icon-cm.png" alt="">
                                </div>
                                <p class="title">{{item.title}}</p>
                            </div>
                            <p class="li_des">{{item.des}}</p>
                        </li>
                    </ul>
                    <p class="cm_btn" data-aos="my-fadeIn" data-aos-once="true" @click="toDetail(list[1].url,list[1].open)">查看详情</p>
                </div>
            </div>
        </div>
        <!-- 工业电商 -->
        <div class="cm_example bg_ff">
            <div class="example_mall common_1180 example_main">
                <img class="img_1" data-aos="my-fadeIn" data-aos-once="true" src="../../assets/img/application-market/cm3.png" alt="">
                <div class="app_main">
                    <p class="cm_title" data-aos="my-fadeIn" data-aos-once="true">{{list[2].title}}</p>
                    <p class="cm_des" data-aos="my-fadeIn" data-aos-once="true">{{list[2].des}}</p>
                    <ul>
                        <li v-for="item in list[2].ul" :key="item.id" data-aos="my-fadeIn" data-aos-once="true">
                            <div class="li_top">
                                <div class="icon">
                                    <img src="../../assets/img/application-market/icon-cm.png" alt="">
                                </div>
                                <p class="title">{{item.title}}</p>
                                <p class="des">{{item.des}}</p>
                            </div>
                        </li>
                    </ul>
                    <p class="cm_btn" data-aos="my-fadeIn" data-aos-once="true" @click="toDetail(list[2].url,list[2].open)">查看详情</p>
                </div>
            </div>
        </div>
        <!-- 知识星球 -->
        <div class="cm_example bg_f8">
            <div class="example_knowledge common_1180 example_main">
                <img class="img_1" data-aos="my-fadeIn" data-aos-once="true" src="../../assets/img/application-market/cm4.png" alt="">
                <div class="app_main">
                    <p class="cm_title" data-aos="my-fadeIn" data-aos-once="true">{{list[3].title}}</p>
                    <p class="cm_des" data-aos="my-fadeIn" data-aos-once="true">{{list[3].des}}</p>
                    <ul>
                        <li v-for="item in list[3].ul" :key="item.id" data-aos="my-fadeIn" data-aos-once="true">
                            <div class="li_top">
                                <div class="icon">
                                    <img src="../../assets/img/application-market/icon-cm.png" alt="">
                                </div>
                                <p class="title">{{item.title}}</p>
                            </div>
                            <p class="li_des">{{item.des}}</p>
                        </li>
                    </ul>
                    <p class="cm_btn" data-aos="my-fadeIn" data-aos-once="true" @click="toDetail(list[3].url,list[3].open)">查看详情</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            list: [
                {
                    title: "应用市场",
                    des: "提供能源化工行业各类APP",
                    ul: [
                        {
                            id: 1,
                            title: "交易有保障",
                            des: "为保障您的资金安全，务必在旭阳云平台下单交易"
                        },
                        {
                            id: 2,
                            title: "服务全程监管",
                            des: "全程透明，阶段性确认，监控质量"
                        },
                        {
                            id: 3,
                            title: "优选服务商",
                            des: "严格的商家把控，保证优质商家"
                        }
                    ],
                    url: "/application-market",
                    open: 0
                },
                {
                    title: "众包市场",
                    des: "覆盖能源化工行业的研发、生产、制造、采购、方案设计、项目实施所有供需对接",
                    ul: [
                        {
                            id: 1,
                            title: "项目撮合",
                            des: "促使需求方与供应方快速对接"
                        },
                        {
                            id: 2,
                            title: "需求定制",
                            des: "满足个性化需求"
                        },
                        {
                            id: 3,
                            title: "交易保障",
                            des: "旭阳云平台交易保障"
                        }
                    ],
                    url: "/supply-and-demand-hall",
                    open: 0
                },
                {
                    title: "工业电商",
                    des: "一站式、电商化的工业品采购",
                    ul: [
                        {
                            id: 1,
                            title: "目录化采购：",
                            des: "支持企业统一采购目录，各组织按需自助采购"
                        },
                        {
                            id: 2,
                            title: "品类丰富：",
                            des: "对接多家MRO工业品和办公用品行业头部平台"
                        },
                        {
                            id: 3,
                            title: "公开透明：",
                            des: "价格与大型电商价格实时联动，享受央企大客户的专属服务"
                        },
                        {
                            id: 4,
                            title: "操作便捷：",
                            des: "全流程电子化操作，使用更加简便快捷"
                        },
                        {
                            id: 5,
                            title: "运营支持：",
                            des: "多家供应商同时平台在线服务，为用户单位提供贴心的超市采购资讯服务"
                        }
                    ],
                    url: "http://emall.risuncloud.com/#/",
                    open: 1
                },
                {
                    title: "知识星球",
                    des: "汇聚行业领域专业知识，提供行业标准、专家分析、市场研究报告等",
                    ul: [
                        {
                            id: 1,
                            title: "知识地图",
                            des: "提供知识查找导航"
                        },
                        {
                            id: 2,
                            title: "知识共享",
                            des: "集中存储、共享分发"
                        },
                        {
                            id: 3,
                            title: "知识问答",
                            des: "助力隐性知识经验沉淀"
                        }
                    ],
                    url: "/knowledge",
                    open: 0
                }
            ]
        }
    },
    methods: {
        toDetail(url, open) {
            if (open === 1) {
                window.open(url)
            } else {
                this.$router.push(url)
            }
        }
    }
}
</script>

<style lang="less" scoped>

.cloud-market {
    .bg_f8 {
        background: #F8F8F8;
    }
    .bg_ff {
        background: #FFFFFF;
    }
    .cm_example {
        padding: 80px 0;
        img {
            display: inline-block;
        }
        .example_main {
            display: flex;
            .app_main {
                flex: 1;
                .cm_title {
                    font-size: 36px;
                    font-weight: bold;
                    color: #333333;
                    line-height: 50px;
                }
                .cm_des {
                    margin-top: 8px;
                    font-size: 18px;
                    color: #484848;
                    line-height: 25px;
                }
                ul {
                    li {
                        margin-top: 32px;
                        .li_top {
                            display: flex;
                            line-height: 25px;
                            font-size: 18px;
                            flex-wrap: wrap;
                            .icon {
                                display: flex;
                                align-items: center;
                                height: 25px;
                                img {
                                    width: 14px;
                                    height: 14px;
                                }
                            }
                            .title {
                                padding-left: 18px;
                                font-weight: bold;
                                color: #333333;
                            }
                            .des {
                                flex: 1;
                                color: #484848;
                            }
                        }
                        .li_des {
                            margin-top: 8px;
                            padding-left: 32px;
                            font-size: 18px;
                            color: #484848;
                            line-height: 25px;
                        }
                    }
                }
            }
            .cm_btn {
                cursor: pointer;
                margin-top: 40px;
                width: 144px;
                height: 44px;
                background: #016EFF;
                text-align: center;
                line-height: 44px;
                font-size: 18px;
                font-weight: 500;
                color: #FFFFFF;
            }
            .cm_btn:hover {
                opacity: 0.8;
            }
        }
        .example_app {
            .img_1 {
                width: 677px; 
                height: 416px;
                margin-top: 25px;
            }
            .app_main {
                padding-left: 50px;
            }
        }
        .example_supply {
            flex-flow:row-reverse;
            .img_1 {
                width: 458px; 
                height: 394px;
                margin-top: 22px;
            }
            .app_main {
                padding-left: 72px;
            }
        }
        .example_mall {
            padding-left: 20px;
            .img_1 {
                width: 509px; 
                height: 321px;
                margin-top: 52px;
            }
            .app_main {
                padding-left: 81px;
            }
        }
        .example_knowledge {
            flex-flow:row-reverse;
            .img_1 {
                width: 519px; 
                height: 519px;
                margin-top: -11px;
            }
            .app_main {
                padding-left: 80px;
            }
        }
    }
}
.cm_banner {
    width: 100%;
    height: 440px;
    box-sizing: border-box;
    background-image: url("../../assets/img/application-market/banner-cm.png");
    padding-top: 153px;
    .iot {
        .iotFont {
            font-size: 36px;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 50px;
            margin-bottom: 24px;
        }
        .iotContent {
            font-size: 16px;
            color: #FFFFFF;
            line-height: 28px;
        }
    }
}
</style>